<script>
import Repositories from '@/repositories';
const OrderMessagesRepository = Repositories.get('ordermessages');
import NoAuthRepositories from '@/repositories/no-authorization';
import dateMixin from '@/mixins/dateMixin';
import MessageItem from './components/message-item.vue';

/**
 * Dashboard Component
 */
export default {
  components: { MessageItem },
  props: {
    orderIdPublic: String,
    userIdPublic: String,
    internalView: { type: Boolean, default: false },
  },
  data() {
    return {
      isLoadingMessages: false,
      newMessage: '',
      newMessageVisible: false,
      isLoadingNewMessage: false,
      messageEdit: '',
      messageEditVisible: false,
      noAuthRepository: null,
      isInternal: false,
      list: [],
    };
  },
  created() {
    this.noAuthRepository = NoAuthRepositories.get(
      'ordermessages',
      this.$route.params.orgcode
    );

    this.loadData();
  },
  mixins: [dateMixin],
  methods: {
    loadData() {
      this.isLoadingMessages = true;
      this.isInternal = this.internalView;

      let getFunction = null;
      if (this.internalView) {
        getFunction = OrderMessagesRepository.customREST.getByOrder(
          this.orderIdPublic
        );
      } else {
        getFunction = this.noAuthRepository.actions.getByOrder(
          this.orderIdPublic
        );
      }

      getFunction
        .then((response) => {
          this.list = response.data.map((x) => {
            x.editionLoading = false;
            return x;
          });
          this.isLoadingMessages = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoadingMessages = false;
        });
    },
    toggleMessage() {
      this.newMessageVisible = !this.newMessageVisible;
    },
    newMessageShown() {
      this.$refs.newmessagetextarea.focus();
    },
    addMessage() {
      this.isLoadingNewMessage = true;

      let payload = {
        orderIdPublic: this.orderIdPublic,
        userIdPublic: this.userIdPublic,
        message: this.newMessage,
        isInternal: this.isInternal,
      };

      let addFunction = null;
      if (this.internalView) {
        payload.userIdPublic = this.userIdPublic;
        payload.isInternal = this.isInternal;

        addFunction = OrderMessagesRepository.create(payload);
      } else {
        addFunction = this.noAuthRepository.create(payload);
      }

      addFunction
        .then(({ data }) => {
          this.list.push({
            ...data,
            userName: this.internalView
              ? this.$store.state.user.config.name
              : null,
            created: new Date().toISOString(),
          });
          this.isLoadingNewMessage = false;
          this.newMessageVisible = false;
          this.newMessage = '';
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoadingNewMessage = false;
        });
    },
    toggleMessageEdit() {
      this.messageEditVisible = !this.messageEditVisible;
    },
    updateMessage(message) {
      let foundIndex = this.list.findIndex(
        (x) => x.idPublic == message.idPublic
      );

      if (foundIndex >= 0) {
        this.list = [
          ...this.list.slice(0, foundIndex),
          { ...this.list[foundIndex], editionLoading: true },
          ...this.list.slice(foundIndex + 1),
        ];

        let queryModel = {
          idPublic: message.idPublic,
          message: message.message,
          orderIdPublic: this.orderIdPublic,
          isInternal: message.isInternal,
        };

        let updateFunction = null;

        if (this.internalView) {
          queryModel.userIdPublic = this.userIdPublic;

          updateFunction = OrderMessagesRepository.update(
            queryModel,
            message.idPublic
          );
        } else {
          updateFunction = this.noAuthRepository.update(
            queryModel,
            message.idPublic
          );
        }

        updateFunction
          .then((x) => {
            this.list = [
              ...this.list.slice(0, foundIndex),
              {
                ...this.list[foundIndex],
                message: x.data.message,
                editionLoading: false,
              },
              ...this.list.slice(foundIndex + 1),
            ];
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.list = [
              ...this.list.slice(0, foundIndex),
              {
                ...this.list[foundIndex],
                editionLoading: false,
              },
              ...this.list.slice(foundIndex + 1),
            ];
          });
      }
    },
  },
  computed: {
    listFiltered() {
      return [
        ...this.list.map((x) => {
          let userName = '';
          let isCurrentUser = false;

          if (x.userIdPublic != null) {
            userName = x.userName;

            if (x.userIdPublic == this.userIdPublic) {
              isCurrentUser = true;
            }
          } else {
            userName = this.$t('messages.supplierMessage');

            if (this.userIdPublic == null) {
              isCurrentUser = true;
            }
          }

          return {
            idPublic: x.idPublic,
            userName: userName,
            isCurrentUser: isCurrentUser,
            date: this.formatDateShort(x.created),
            message: x.message,
            isInternal: x.isInternal,
            editionLoading: x.editionLoading,
          };
        }),
      ].reverse();
    },
  },
};
</script>

<template>
  <div class="customScrollbarAlwaysOn">
    <div style="display: flex; align-items: center">
      <i class="mdi mdi-36px mdi-comment-text-outline"></i>
      <h5 style="margin-left: 12px">{{ $t('messages.messages') }}</h5>
      <i
        @click="toggleMessage"
        class="fas fa-plus text-success"
        style="margin: 0 10px 0 auto; font-size: 1.3em; cursor: pointer"
      ></i>
    </div>

    <div
      style="background-color: wite; overflow: hidden scroll; max-height: 460px"
    >
      <b-collapse
        id="collapse-new-message"
        v-model="newMessageVisible"
        @shown="newMessageShown"
      >
        <div class="ml-1 mr-1 mb-2">
          <textarea
            ref="newmessagetextarea"
            @keydown.enter.ctrl.exact.prevent="addMessage"
            @keydown.escape.exact.prevent="toggleMessage"
            rows="6"
            style="width: 100%"
            class="rounded"
            v-model="newMessage"
          />
          <div class="flex-box" style="white-space: nowrap">
            <b-button
              v-if="isLoadingNewMessage"
              disabled
              style="width: 160px"
              variant="warning"
              @click="addMessage"
            >
              <i
                class="fas fa-spinner fa-spin"
                style="font-size: 1.3em; color: white"
              ></i>
            </b-button>
            <b-button
              v-else
              style="width: 160px"
              variant="info"
              @click="addMessage"
            >
              {{ $t('messages.addMessage') }}
            </b-button>
            <b-form-checkbox
              v-if="internalView"
              class="flex-push"
              v-model="isInternal"
              name="checkbox-is-internal"
            >
              {{ $t('messages.internalMessage') }}
            </b-form-checkbox>
          </div>
        </div>
      </b-collapse>

      <MessageItem
        v-for="message in listFiltered"
        :key="message.idPublic"
        :message="message"
        :internalView="internalView"
        :orderIdPublic="orderIdPublic"
        :userIdPublic="userIdPublic"
        :editionLoading="message.editionLoading"
        @update-message="updateMessage"
      />
      <div
        v-show="list.length == 0"
        class="flex-center-align"
        style="min-height: 50px"
      >
        <div class="text-center" style="white-space: pre">
          {{ $t('messages.noMessage') }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>